import { useInfiniteOrganizationSetQuery } from "@smp/graphql";
import { useMemo } from "react";

import { gqlClient } from "@/hooks/use_graphql";
import { gscSendUserParams } from "@/utils";

export const useEpOrganizationOrganizationList = () => {
  const queryOrganizationSet = useInfiniteOrganizationSetQuery(
    "id__in",
    gqlClient,
    undefined,
    {
      onSuccess: (data) => {
        const num = data.pages.reduce((acc, page) => {
          acc += page.organization_set.length;

          return acc;
        }, 0);

        gscSendUserParams({
          organization: num,
        });
      },
    },
  );

  const organizationList = useMemo(
    () =>
      queryOrganizationSet.data?.pages.flatMap((page) => page.organization_set),
    [queryOrganizationSet.data?.pages],
  );

  return {
    isOrganizationListLoading: queryOrganizationSet.isLoading,
    organizationList,
  };
};

useEpOrganizationOrganizationList.KEY =
  useInfiniteOrganizationSetQuery.getKey();
